module.exports = __webpack_public_path__ + "static/media/male_front.b9eeb1dd.jpg";